module.exports = __webpack_public_path__ + "380bb27897e3d163bc0803df0072c6cd.svg";